<h2 mat-dialog-title>Duplicate Code!</h2>
<div mat-dialog-content>
  <p>The code you are trying to create already exists in your {{shopName}} Dashboard.</p>
  <p>Would you like to import it?</p>
</div>
<div mat-dialog-actions class="d-flex justify-content-end">
  <button mat-button [mat-dialog-close]="true">Enter Different Code</button>
  <button mat-button (click)="onImportCodeClicked()">Import Existing Code</button>
</div>
